
<template>
  <div>
      <form class="modal fade" method="post" id="leaveReview" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Leave a Review</h4>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="review-name">Your Name</label>
                  <input class="form-control" type="text" id="review-name" required>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="review-email">Your Email</label>
                  <input class="form-control" type="email" id="review-email" required>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="review-subject">Subject</label>
                  <input class="form-control" type="text" id="review-subject" required>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="review-rating">Rating</label>
                  <select class="form-control" id="review-rating">
                    <option>5 Stars</option>
                    <option>4 Stars</option>
                    <option>3 Stars</option>
                    <option>2 Stars</option>
                    <option>1 Star</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="review-message">Review</label>
              <textarea class="form-control" id="review-message" rows="8" required></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" type="submit">Submit Review</button>
          </div>
        </div>
      </div>
      </form>
 <!-- Page Content-->
    <div class="bg-secondary pb-4 padding-top-3x mt-30">
      <div class="container">
        <div class="row">
          <!-- Product Gallery-->
          <div class="col-md-6 mb-30">
            <div class="product-gallery"><span v-if="product.sales" class="product-badge text-danger">
              {{product.discount}}</span>
              <!--<img :src="product.img" alt="Product">-->
              <v-zoom :img="product.img" :width="555" :magnify="1"></v-zoom>
             <!-- <div class="product-carousel owl-carousel gallery-wrapper">
                <div class="gallery-item" data-hash="one">
                  <a :href="product.img" data-size="555x480"></a>
                  <v-zoom :img="product.img" :width="555"></v-zoom>
                </div>
              </div>
              -->
            </div>
          </div>
          <!-- Product Info-->
          <div class="col-md-6 mb-30">
            <div class="card border-default bg-white pt-2 box-shadow">
              <div class="card-body">
                <h2 class="mb-3"><strong>{{product.name}}/{{product.id}}</strong></h2>


 <span class="h6 d-block">
              <del class="text-muted text-normal">{{product.price2}} DA</del>&nbsp;{{product.price}} DA</span>


                <p class="text-sm text-muted"><strong>{{product.description}}</strong></p>

                <div class="row align-items-end mb-4">
                  <div class="col-sd-4">
                    <div class="form-group mb-0">
                      <p class="text-normal"><strong>&nbsp; &nbsp;   Garantie : 24 mois &nbsp; &nbsp;</strong></p>
                       <p class="text-normal"><strong>&nbsp; &nbsp;   Service aprés vente&nbsp; &nbsp; </strong></p>
                       <p class="text-normal"><strong> &nbsp; &nbsp; Livraison gratuite &nbsp; &nbsp; </strong></p>
                       <br>
                        <br>
                         <br>
                    </div>
                  </div>
                  <div class="accordion" id="accordion1" role="tablist">

            </div>

                  <div class="col-sm-8">
                    <div class="pt-4 hidden-sm-up"></div>
                    <button class="btn btn-primary btn-block my-0" @click="addToCart(product)">Ajouter au panier</button>

                  </div>
  </div>
                <ul class="list-unstyled text-sm mb-4">
                  <li><span class='text-dark text-medium'>Reférence:</span> {{product.id}}</li>
                  <li><span class='text-dark text-medium'>Categories:</span>
                  <a href='#' class='navi-link'>Montre</a>
                  <a href='#' class='navi-link'>{{product.name}}</a>
                  </li>
                </ul>
                <div class="d-flex flex-wrap justify-content-between align-items-center">

                  <div class="py-2">
                    <a class="social-button shape-rounded sb-facebook" href="#" data-toggle="tooltip"
                    data-placement="top" title="Facebook">
                    <i class="socicon-facebook"></i></a>
                    <a class="social-button shape-rounded sb-twitter" href="#" data-toggle="tooltip"
                    data-placement="top" title="Twitter"><i class="socicon-twitter"></i></a>
                    <a class="social-button shape-rounded sb-instagram" href="#"
                    data-toggle="tooltip"
                    data-placement="top" title="Instagram"><i class="socicon-instagram"></i></a>
                    <a class="social-button shape-rounded sb-google-plus" href="#"
                    data-toggle="tooltip" data-placement="top" title="Google +"><i class="socicon-googleplus"></i></a></div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>





  </div>

</template>
    <!-- JavaScript (jQuery) libraries, plugins and custom scripts-->
    <script src="js/vendor.min.js"></script>
    <script src="js/scripts.min.js"></script>
    <!-- Customizer scripts-->
    <script src="customizer/customizer.min.js"></script>
<script>
//for carousel in home page
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import $ from 'jquery';
import vZoom from 'vue-zoom';

import { mapGetters, mapActions } from 'vuex';
import eventBus from '../main.js';

export default {
   components: {
    vZoom
  },
  data() {
    return {
      show: true
    };
  },
  computed: {
    fetchComplete() {
      return this.$store.state.fetchDatapromo;
    },


     ...mapGetters({
    products2: 'lastProductspromos',
      product: 'detailProduct', //<=>this.$store.getters.detailProducts
    images: 'allImages'
    })

  },

   watch: {
    fetchComplete() {
      if (this.fetchComplete) {
        //create the owl carousel until i fetch the data fechedData=true in the store
        this.$nextTick(() => {
          $('#top-category').owlCarousel({
            nav: false,
            dots: true,
            margin: 30,
            responsiveClass: true,
            autoplay :true,
            autoplayTimeout :7000,
            loop :true,
            dots:true,
            responsive: {
              0: { items: 1 },
              576: { items: 2 },
              768: { items: 3 },
              991: { items: 4 },
              1200: { items: 4 }
            }
          });
             $('#top-categoryH').owlCarousel({
            nav: false,
            dots: true,
            margin: 30,
            responsiveClass: true,
            autoplay :true,
            autoplayTimeout :7000,
            loop :true,
            dots:true,
            responsive: {
              0: { items: 1 },
              576: { items: 2 },
              768: { items: 3 },
              991: { items: 4 },
              1200: { items: 4 }
            }
          });
      });
      }
    }
  },
  //need this for redirection from another page like from all back to home
  mounted() {
    if (this.fetchComplete) {
      this.$nextTick(() => {
        $('#top-category').owlCarousel({
          nav: false,
          dots: true,
          margin: 30,
          responsiveClass: true,
          autoplay :true,
            autoplayTimeout :7000,
            loop :true,
            dots:true,
          responsive: {
            0: { items: 1 },
            576: { items: 2 },
            768: { items: 3 },
            991: { items: 4 },
            1200: { items: 4 }
          }
        });
             $('#top-categoryH').owlCarousel({
          nav: false,
          dots: true,
          margin: 30,
          responsiveClass: true,
          autoplay :true,
            autoplayTimeout :7000,
            loop :true,
            dots:true,
          responsive: {
            0: { items: 1 },
            576: { items: 2 },
            768: { items: 3 },
            991: { items: 4 },
            1200: { items: 4 }
          }
        });
      });
    }
  },
  created() {
     const refe = this.$route.params.ref ;
    this.$store.dispatch('fetchDataref', { refe: refe });

this.$nextTick(() => {
      $('#mhdfeature').owlCarousel({
        nav: false,
        dots: true,
        margin: 30,
        responsive: {
          0: { items: 1 },
          576: { items: 2 },
          768: { items: 3 },
          991: { items: 3 },
          1200: { items: 3 }
        }
      });
      $('#slide').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 8000
      });
  $('#brands').owlCarousel({
        nav: false,
        dots: false,
        loop: true,
        autoplay: true,
        autoplayTimeout: 4000,
        responsive: {
          0: { items: 2 },
          470: { items: 3 },
          630: { items: 4 },
          991: { items: 5 },
          1200: { items: 6 }
        }
      });


    });


  },



  data() {
    return {
      sales: false,
      discount: 0
    };
  },

  methods: {
    addToCart: function(item) {
      this.$store
        .dispatch('addToCart', item)
        .then(() => {
          this.$notify({
            group: 'cart',
            title: 'Product',
            type: 'success',
            text: 'vous avez ajouter un produit au panier'
          });
        })
        .catch(error => console.log(error));
    },

    ...mapActions(['addToCart'])
  }
};
</script>

<style scoped>
.card-img-top {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}
.card-img-top2 {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}



.men-card {
  background-image: url('/static/img/shop/categories/luipc.jpg');
  background-size: cover;
  height: 100%;

}
@media  (max-width: 600px) {
 .men-card  {
  background-image: url('/static/img/shop/categories/luipcmobile.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 25vh;
  margin-bottom: 10px;
}


}
.women-card {
  background-image: url('/static/img/shop/categories/womenpc.jpg');
  background-size: cover;
  height: 100%;
}
@media  (max-width: 600px) {
 .women-card  {
  background-image: url('/static/img/shop/categories/womenmobile.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
    height: 25vh;
  margin-bottom: 10px;


}
}
.women-card img {
  opacity: 0;
  /*or visibility: hidden;*/
}

.men-card img {
  opacity: 0;
}

.women-card h3 {
  font-size: 1em;
  color: whitesmoke;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 0.3em;
}

.men-card h3 {
  font-size: 1em;
  color: whitesmoke;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 0.3em;
}

.women-card button {
  z-index: 1;
  opacity: 0;
  transition: opacity 0.35s;
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.women-card:hover button {
  opacity: 1;
}


.card-body button {
  position: absolute;
  right: 0;
  bottom: 5px;
}

.product-card-buttons:active button {
  opacity: 1;
}
.product-card-buttons:focus button {
  opacity: 1;
}
.bg {
  background-image: url('/static/img/home.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 70vh;
  margin-bottom: 30px;


}
.mr-top-30 {
  margin-top: 30px;
}
.mr-top-40 {
  margin-top: 40px;
}
@media  (max-width: 900px) {
 .bg {
  background-image: url('/static/img/homemobile.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 60vh;
  margin-bottom: 30px;
}


}



</style>









// WEBPACK FOOTER //
// src/components/productref.vue